<script>
    import { mapActions, mapState } from "vuex";
    import { metaInfo } from "@/core/MetaInfo";
    import TypographyWrapper from "@/components/TypographyWrapper";

    export default {
        name: "DocumentLoyalty",
        components: { TypographyWrapper },
        computed: {
            ...mapState("Root", {
                page: (state) => state.staticPage["document-loyalty"],
            }),
        },
        serverPrefetch() {
            return this.getStaticPage({ slug: "document-loyalty" });
        },
        mounted() {
            if (!this.page?.slug) {
                this.getStaticPage({ slug: "document-loyalty" });
            }
        },
        methods: {
            ...mapActions("Root", ["getStaticPage"]),
        },
        metaInfo() {
            return metaInfo.getMeta("document-loyalty");
        },
    };
</script>

<template>
    <div class="document-loyalty">
        <div class="l-container">
            <typography-wrapper>
                <h2>Условия и&nbsp;общие положения программы лояльности</h2>
                <div class="document-loyalty__content" v-html="page.contentRight"></div>
            </typography-wrapper>
        </div>
    </div>
</template>

<style lang="scss">
    .document-loyalty {
        padding-bottom: 56px;
        background-color: var(--document-background-color);
        h2 {
            max-width: 900px;
            margin-left: auto;
            margin-right: auto;
            text-align: center;
        }
    }

    .document-loyalty__content {
        padding: 16px;
        background-color: var(--service-background-color);
        border: var(--service-border);
        border-radius: var(--service-border-radius);
        @include bp($bp-desktop-sm) {
            padding: 26px 32px 12px;
        }
    }
</style>
